/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import styled from "styled-components";
import PreviousIcon from "../../../../assets/prev.svg";
import NextIcon from "../../../../assets/next.svg";
import useBreaksStore from "../../../../store/breaks";
import { TextField, Tooltip, withStyles } from "@material-ui/core";
interface AdHeaderProps {
  id: string;
  sequence: number;
  onNext: () => void;
  onPrev: () => void;
  onExhibitions: (index: number) => void;
  exhibitions: number;
  inputIndex: string;
  onInputIndexChange: (value: string) => void;
  onCommitIndex: () => void;
}

export const AdHeader: React.FC<AdHeaderProps> = ({
  id,
  sequence,
  onNext,
  onPrev,
  onExhibitions,
  exhibitions,
  inputIndex,
  onInputIndexChange,
  onCommitIndex,
}) => {
  const numbers = Array.from({ length: exhibitions }, (_, index) => index + 1);

  const { setPosition } = useBreaksStore();

  return (
    <HeaderContainer>
      <SequenceGroup>
        <a
          type="button"
          onClick={() => {
            onPrev();
          }}
          aria-label="Previous Sequence"
        >
          <Icon
            loading="lazy"
            src={PreviousIcon}
            alt="Sequence indicator icon"
          />
        </a>
        <Tooltip title="Digite o número do bloco (1 a 9999)" arrow>
          <TextField
            variant="outlined"
            value={inputIndex}
            size="small"
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d{0,4}$/.test(val)) onInputIndexChange(val);
            }}
            onBlur={onCommitIndex}
            onKeyDown={(e) => {
              if (e.key === "Enter") onCommitIndex();
            }}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            InputProps={{
              style: {
                backgroundColor: "rgba(177, 216, 255, 1)",
                height: 36,
                width: 64,
                textAlign: "center",
                borderRadius: 6,
              },
              inputProps: {
                style: {
                  textAlign: "center",
                  padding: "6px 0",
                },
              },
            }}
          />
        </Tooltip>

        <a
          type="button"
          onClick={() => {
            onNext();
          }}
          aria-label="Next Sequence"
        >
          <Icon loading="lazy" src={NextIcon} alt="" />
        </a>
      </SequenceGroup>
      <SequenceText>
        <Container>
          <NumbersContainer>
            {numbers.map((number, index) => (
              <Numbers
                type="button"
                aria-label="Go to break"
                key={number}
                onClick={() => {
                  setPosition(index + 1);
                  onExhibitions(index);
                }}
              >
                {number === sequence ? (
                  <HighlightedNumber>{number}</HighlightedNumber>
                ) : (
                  number
                )}
              </Numbers>
            ))}
          </NumbersContainer>
        </Container>
      </SequenceText>
    </HeaderContainer>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-family: "Roboto", "Montserrat";
`;

const NumbersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  cursor: pointer;
`;

const Numbers = styled.a`
  margin: 5px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
`;

const HeaderContainer = styled.div`
  border-radius: 3px 3px 0 0;
  background-color: rgba(21, 137, 251, 1);
  display: flex;
  width: 100%;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
  font-size: 16px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const SequenceGroup = styled.div`
  display: flex;
  align-items: start;
  gap: 6px;
  color: rgba(80, 80, 80, 1);
  font-weight: 700;
  white-space: nowrap;
  line-height: 1.7;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const Icon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 18px;
  margin-top: 50%;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
`;

const SequenceText = styled.div`
  color: rgba(255, 255, 255, 1);
  font-weight: 400;
  margin: auto 0;
`;

const HighlightedNumber = styled.span`
  font-weight: 800;
  color: rgba(80, 80, 80, 1);
`;
